import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { EMPTY_STATE_CONTENT } from "../../constants";

export default function EmptyState({ emptyStateKey, emptyStateHeight }) {
  const content = EMPTY_STATE_CONTENT[emptyStateKey];

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: emptyStateHeight,
        textAlign: "center",
      }}
    >
      {content.emptyStateTitle && (
        <Typography variant="h5" color="white">
          {content.emptyStateTitle}
        </Typography>
      )}
      {content.emptyStateSubtitle && (
        <Typography
          variant="body1"
          color="white"
          sx={{
            maxWidth: "900px",
            lineHeight: 1.6,
            px: 2,
          }}
        >
          {content.emptyStateSubtitle}
        </Typography>
      )}
      {content.addWallet && (
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={() => navigate("/payments")}
        >
          {content.addWallet}
        </Button>
      )}
    </Box>
  );
}
